export const LANDING = '/';
export const LOGIN = '/login';
export const LOGOUT = '/logout';

export const SIGNIN = '/signin';
export const SIGNOUT = '/signout';
export const SIGNUP = '/signup';

export const USAGE = '/usage';

export const MEDITATION = '/meditation';
export const MUSIC = '/music';
export const LIGHTCYCLE = '/light-cycle';
export const EQUITY = '/equity';
export const DESKTOP_AUTH = '/desktop-auth';
export const WEDDING = '/wedding';
export const TRADING = '/trading';
export const SYNTH = '/synth';
